import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const AboutSection = () => {
  const { language } = useLanguage();
  
  const services = language === "en" 
    ? [
        "Professional moving assistance",
        "IKEA furniture assembly and installations",
        "Wall repairs and TV mounting",
        "General handyman services",
        "Fast and professional movers and repairers"
      ]
    : [
        "Ammattitaitoinen muuttoapu",
        "IKEA-kaappien kokoaminen ja asennukset",
        "Seinäkorjaukset ja TV-kiinnitys",
        "Yleiset käsityöpalvelut",
        "Nopeat ja ammattimaiset muuttajat ja korjaajat"
      ];

  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-8">
            {language === "en" ? "Over 10 years of experience" : "Yli 10 vuoden kokemus"}
          </h2>
          
          <h3 className="text-2xl md:text-4xl font-bold text-primary mb-4">
            {language === "en" 
              ? "Moving and handyman services in Helsinki when you need them!"
              : "Tarvittaessa muutto- ja käsityöpalvelut Helsingissä!"
            }
          </h3>
          
          <div className="text-3xl font-bold text-accent mb-8">
            {language === "en" ? "Only " : "Vain "}
            <span className="text-primary">
              {language === "en" ? "from 38 € per hour + VAT" : "alkaen 38 € per tunti + ALV"}
            </span>
          </div>
          
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            {language === "en" 
              ? "With over 10 years of experience, we offer:"
              : "Yli 10 vuoden kokemuksella tarjoamme:"
            }
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 text-left max-w-2xl mx-auto">
            {services.map((service, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className="w-2 h-2 bg-accent rounded-full"></span>
                <span className="text-foreground">{service}</span>
              </div>
            ))}
          </div>
          
          <p className="text-lg text-muted-foreground mb-8">
            {language === "en"
              ? "Let us handle the heavy lifting and repairs — so you can enjoy peace of mind!"
              : "Anna meidän hoitaa raskaat nostot ja korjaukset — jotta voit nauttia mielenrauhasta!"
            }
          </p>
          
          <Button 
            variant="secondary" 
            size="lg" 
            className="bg-accent text-black hover:bg-accent-dark whitespace-nowrap" 
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
          >
            {language === "en" ? "Learn more" : "Tutustu lisää"}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
